import { ShipmentSavedSearch } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment/saved-search';

export class ShipmentSavedSearchController extends BaseHttpController {
  constructor() {
    super(endpoint, { useSelectedDomainContext: true });
  }

  async findAllGlobal(): Promise<ShipmentSavedSearch[]> {
    const response = await this.http.get<ShipmentSavedSearch[]>('global');
    return response.data.map(
      (val) => new ShipmentSavedSearch({ ...val, isPopularSearch: true }),
    );
  }

  async findAllForUser(): Promise<ShipmentSavedSearch[]> {
    const response = await this.http.get<ShipmentSavedSearch[]>('');
    return response.data.map((val) => new ShipmentSavedSearch(val));
  }

  async create(
    shipmentSavedSearch: ShipmentSavedSearch,
  ): Promise<ShipmentSavedSearch> {
    if (shipmentSavedSearch.id != null) {
      throw new Error('Id expected to be null when calling create');
    }

    const response = await this.http.post<ShipmentSavedSearch>('', {
      shipmentSavedSearch,
    });
    return new ShipmentSavedSearch(response.data);
  }

  async update(
    shipmentSavedSearch: ShipmentSavedSearch,
  ): Promise<ShipmentSavedSearch> {
    if (shipmentSavedSearch.id === undefined) {
      throw new Error('Id expected to be defined when calling update');
    }

    const response = await this.http.put<ShipmentSavedSearch>('', {
      shipmentSavedSearch,
    });
    return new ShipmentSavedSearch(response.data);
  }

  async delete(searchId: number): Promise<void> {
    await this.http.delete<void>(`${searchId}`);
  }
}
